import { AuthContextProvider } from "./context";
import AppRoutes from "./routes/Index";

const App = () => {
    return (
        <AuthContextProvider>
            <AppRoutes />
        </AuthContextProvider>
    );
}

export default App;
